import { render } from "./waitlist.vue?vue&type=template&id=25b1d7ba"
import script from "./waitlist.vue?vue&type=script&lang=js"
export * from "./waitlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__